import api from '@/services/ApiServices'
import IHomeBanner from '@/models/homebanners/implements/IHomeBanner.type'
import HomeBanner from '@/models/homebanners/HomeBanner'

class HomeServices {
  getBanner (locale : string) {
    return api.get<IHomeBanner>('/banner', {
      params: { language: locale }
    }).then(response => new HomeBanner(
      response.data.Id,
      response.data.Name,
      response.data.Description,
      new Date(response.data.DateCreation)
    ))
  }
}

export default new HomeServices()
